import { Dialog } from "@src/components/Dialog";
import type { Translate } from "@src/i18n/translate";

export type ShareDialog = "share" | "share-error";
export type ShareCopyOutcome = "copied" | "manual";

export interface ShareDialogsProps {
  dialog: ShareDialog | null;
  setDialog: (dialog: ShareDialog | null) => void;
  t: Translate;
  shareLink: string;
  shareCopyOutcome: ShareCopyOutcome;
  onRecoverInvalidShare: () => void;
  returnFocus?: HTMLElement | null | undefined;
}

export function ShareDialogs({
  dialog,
  setDialog,
  t,
  shareLink,
  shareCopyOutcome,
  onRecoverInvalidShare,
  returnFocus,
}: ShareDialogsProps) {
  const close = () => {
    setDialog(null);
  };
  return (
    <>
      <Dialog
        open={dialog === "share"}
        onClose={close}
        className="share-dialog"
        labelledBy="share-dialog-title"
        returnFocus={returnFocus}
      >
        <div className="share-dialog-content">
          <h1 id="share-dialog-title">
            {t(
              shareCopyOutcome === "copied"
                ? "shareCopiedTitle"
                : "shareManualTitle",
            )}
          </h1>
          <p>
            {t(
              shareCopyOutcome === "copied"
                ? "shareCopiedDescription"
                : "shareManualDescription",
            )}
          </p>
          <input
            id="share-link"
            className="share-link"
            name="share-link"
            type="text"
            readOnly
            value={shareLink}
            aria-label={t("shareLink")}
            onFocus={(event) => {
              event.target.select();
            }}
          />
          <button type="button" onClick={close}>
            {t("close")}
          </button>
        </div>
      </Dialog>
      <Dialog
        open={dialog === "share-error"}
        onClose={onRecoverInvalidShare}
        className="share-error-dialog"
        labelledBy="share-error-title"
        dismissible={false}
        returnFocus={returnFocus}
      >
        <div className="share-error-content">
          <h1 id="share-error-title">{t("invalidShareTitle")}</h1>
          <p>{t("invalidShareDescription")}</p>
          <button type="button" onClick={onRecoverInvalidShare}>
            {t("close")}
          </button>
        </div>
      </Dialog>
    </>
  );
}
